import React from "react";

interface Props {
  label: string;
  onClick?: () => void;
  className?: string;
  labelClassName?: string;
}

function LabelButton(props: Props) {
  return (
    <button
      onClick={props.onClick}
      className={
        "flex h-[24px] w-[86px] rounded-full items-center justify-center bg-black " +
        props.className
      }
    >
      <p className={"text-white text-xxs font-bold " + props.labelClassName}>
        {props.label}
      </p>
    </button>
  );
}

export default LabelButton;
